import React, { HTMLAttributes, useEffect, useMemo, useState, forwardRef, useImperativeHandle } from "react";
import cx from "classnames";
import { Hooks, Request } from "@xt/xtbase";
const { XtAxios4 } = Request;
import { useStore } from "../../store";
import { get_tokenSendCode } from "../../api/uaapi/uaa";
import { post_msgDoSendCode } from "../../api/uaapi/user";
import styles from "./index.module.scss";
import stylesCommon from "../../common.module.scss";
import { Canceler } from "axios";
import { message } from "antd";

export interface ExposeDynamicProps {
  handleClick(bool: boolean): Promise<any>;
}
export interface DynamicProps extends HTMLAttributes<HTMLDivElement> {
  ref?: CompRef<ExposeDynamicProps>;
  attr?: any;
  isNew?: boolean;
  emailNew?: string;
  mobileNew?: string;
  label?: string;
  disabled?: boolean;
  isAuthorize?: boolean;
  codeType?: string | number;
  countryCode?: string | number;
  // userName?: string;
  puzzleValidateString?: string;
  receiveAddress?: string;
  faCheckId?: string;
  msgType?: string | number;
  FaValidTypeDict?: "EMAIL" | "MOBILE"; // 验证类型
  disableClick?: boolean;
  accountId?: string | number;
  noEmailChange?(): any;
  onClick?(): void;
  updateDisabled?: (arg: boolean) => void;
  msgSendDataObj?: any;
}
const { useTranslation } = Hooks;
const { asyncAwait } = XtAxios4;
const Dynamic = (
  {
    className,
    label,
    emailNew,
    isNew,
    mobileNew,
    FaValidTypeDict,
    disabled = false,
    isAuthorize,
    codeType = 199,
    countryCode = "",
    // userName = store.user.isLogin ? store.user.userInfo?.userName : "",
    puzzleValidateString,
    receiveAddress,
    faCheckId,
    msgType = 0,
    disableClick = false,
    accountId = 0,
    noEmailChange,
    onClick,
    updateDisabled,
    msgSendDataObj,
  }: DynamicProps,
  ref: DynamicProps["ref"]
) => {
  let TimeoutFun: Timeout, CancelFun: Canceler;
  const t = useTranslation();
  const { userInfo } = useStore();
  const [loading, setLoading] = useState(false);
  const [second, setSecond] = useState(0);

  const mobile = useMemo(() => {
    return isNew ? mobileNew : userInfo?.mobile;
  }, [userInfo, isNew, mobileNew]);

  const email = useMemo(() => {
    return isNew ? emailNew : userInfo?.email;
  }, [userInfo, emailNew]);

  const getTxt = useMemo(() => {
    return second ? `${second}s` : label || t("@xt/Passkey.getCode");
  }, [second, label]);

  const isDisabled = useMemo(() => {
    return !!(disabled || loading || second);
  }, [disabled, loading, second]);
  useEffect(() => {
    updateDisabled && updateDisabled(!!(loading || second));
  }, [loading, second]);

  useImperativeHandle(ref, () => ({
    handleClick,
  }));

  useEffect(() => {
    return () => {
      clearTimeout(TimeoutFun!);
      CancelFun && CancelFun();
    };
  }, []);


  // 验证手机号是否合法
  const verifyPhone = (phone = "") => {
    const reg = /^[0-9]{5,11}$/;
    return reg.test(phone);
  };
  // 验证邮箱是否合法
  const verifyEmail = (email = "") => {
    const reg = /^([a-zA-Z0-9_.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/;
    return reg.test(email);
  };

  const handleClick = async (bool: boolean) => {
    console.log(disableClick, bool, 'bool');
    if (disableClick && bool !== true) return onClick?.();
    if (isAuthorize) return handleAuthorize();
    // 认证手机107 修改手机111
    console.log(receiveAddress, 'receiveAddress');
    let address = receiveAddress;
    if (FaValidTypeDict == "MOBILE" && isNew) {
      if (!verifyPhone(mobile)) return message.error(t("@xt/Passkey.plsInputPhone"));
      address = mobile;
    } else {
      if (isNew) {
        // 认证邮箱 105
        if (!verifyEmail(email)) return message.error(t("@xt/Passkey.emailAddress"));
        address = email;
      }

    }
    // 通用型检测
    // if (userName && !mobile && !email) return message.error(t("cmpt.errName"));
    if (msgType == 2) {
      noEmailChange && noEmailChange();
    }
    setLoading(true);
    const uaapiAry = [
      "101", //注册验证码
      "102", //找回登陆密码验证码
      "103", //找回安全密码验证码
      "105", //认证邮箱邮箱验证码
      "106", //认证邮箱手机验证码
      "107", //认证手机手机验证码
      "108", //认证手机邮箱验证码
      "109", //修改手机邮件验证码
      "110", //修改手机旧手机验证码
      "111", //修改手机新手机验证码
      "199", //验证码
      "USER_2004", //绑定手机号
      "USER_2005", //更改手机号
      "USER_2006", //绑定邮箱
      "USER_2007", //更改邮箱
      "USER_2008", //更改登录密码
      "USER_2009", //更改安全密码
      "USER_2010", //重置安全密码
      "USER_2011", //设置防钓鱼码
      "USER_2012", //更改防钓鱼码
      "USER_2013", //绑定谷歌身份验证器
      "USER_2014", //解绑谷歌身份验证器
      "USER_2015", //重置邮箱
      "USER_2016", //重置手机
      "USER_2017", //重置谷歌验证
      "USER_2018", //重置邮箱+手机
      "USER_2019", //重置手机+谷歌验证器
      "USER_2020", //重置邮箱+谷歌验证器
      "USER_2021", //重置邮箱+手机+谷歌验证器
      "WALLET_2001", //保存提币地址
      "WALLET_2002", //提币
      "WALLET_2003", //快捷 提币
      "WALLET_2004", // 保存白名单地址

      "OTC_2001", //OTC-发布广告
      "OTC_2002", //OTC-添加/修改支付方式
      "USER_2022", //初级认证
      "USER_2023", //高级认证
      "USER_2024", //创建api认证
      "USER_2025", //修改api认证
      "USER_2026",
      "USER_2027",
      "USER_2028",
      "USER_2029",
      "USER_2030",
    ];
    const paramsData = {
      codeType,
      countryCode: countryCode || userInfo?.countryCode,
      faCheckId,
      msgType,
      receiveAddress: address,
      puzzleValidateString,
      regChannel: "xt",
      ...(accountId ? { accountId } : {}),
      ...(msgSendDataObj || {}),
    };


    if (FaValidTypeDict == "EMAIL") {
      delete paramsData.countryCode;
    }
    const { data, err } = await asyncAwait(post_msgDoSendCode, {
      errorPop: true,
      params: {
        codeType,
      },
      data: {
        ...paramsData,
      },
    });
    if (!err) todoSuccess(data);
    setLoading(false);
  };
  const handleAuthorize = async () => {
    setLoading(true);
    const { data, err } = await asyncAwait(get_tokenSendCode, {
      params: {
        mfaId: typeof window === "undefined" ? undefined : window.sessionStorage.getItem("mfaId"),
      },
    });
    setLoading(false);
    if (err) return;
    todoSuccess(data);
  };
  const todoSuccess = (data: any) => {
    if (data.receiveAddress) message.success(t("@xt/Passkey.codeSend", [data.receiveAddress]));
    else message.success(t("@xt/Passkey.codeSend1"));
    TimeoutFun && clearTimeout(TimeoutFun);
    setSecond(60);
    countDown();
  };

  const countDown = () => {
    // 定时器闭包陷阱解决 useEffect,useRef,函数式更新状态
    TimeoutFun = setTimeout(() => {
      setSecond((second) => {
        if (second <= 0) {
          clearTimeout(TimeoutFun!);
          return 0;
        }
        return second - 1;
      });
      countDown();
    }, 1000);
  };
  return (
    <button
      className={cx(stylesCommon.btnTxt, styles["app-code-dynamic"], className)}
      disabled={isDisabled}
      onClick={(e) => {
        e.stopPropagation;
        handleClick(false);
      }}
    >
      {getTxt}
    </button>
  );
};
export default forwardRef(Dynamic) as React.FC<DynamicProps>;
